// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_v7fkC","footer":"footer_ayVRS"};